module.exports = __webpack_public_path__ + "static/media/icon-tel-hover.fcc8c2ce.png";